(function() {
    'use strict';

    angular.module('allegro').controller('AllegroOfferUpdateController', AllegroOfferUpdateController);

    AllegroOfferUpdateController.$inject = [
        '$scope',
        '$state',
        '$q',
        'allegroOffersDataSrvc',
        'allegroOfferMessagesConst',
        'productSrvc',
        'productDataSrvc',
        'productOptionDataSrvc',
        'allegroAccountDataSrvc',
        'allegroSrvc',
        'notificationSrvc',
        'errorNotificationSrvc'
    ];

    function AllegroOfferUpdateController(
        $scope, $state, $q, allegroOffersDataSrvc, allegroOfferMessagesConst, productSrvc, productDataSrvc,
        productOptionDataSrvc, allegroAccountDataSrvc, allegroSrvc, notificationSrvc, errorNotificationSrvc
    ) {
        var self = this;

        self.loading = false;
        self.saving = false;

        self.serverErrors = {};
        self.modalData = {
            categoryNameForSearch: null,
            category: {},
            breadcrumbCategories: []
        };
        self.productOpts = [];
        self.productQuantityOpts = [];
        self.productGroupOptionsOpts = [];
        self.shoppingRateOpts = [];
        self.impliedWarrantyOpts = [];
        self.returnPolicyOpts = [];
        self.publicationDurationOpts = [];
        self.deliveryHandlingTimeOpts = [];

        self.selectedProductOptions = {};
        self.isProductDataComplete = true;

        self.account = {};
        self.offerSignature = '';
        self.offerData = {
            product: null,
            quantity: null,
            chosen_options: [],
            title: '',
            description: '',
            available_number: null,
            price: null,
            publication_duration: null,
            republish: false,
            delivery_handling_time: null,
            data: {
                category: null,
                parameters: [],
                shoppingRate: null,
                impliedWarranty: null,
                returnPolicy: null
            },
        };

        self.onInitView = onInitView;
        self.getOffer = getOffer;
        self.updateOffer = updateOffer;
        self.getProducts = getProducts;
        self.getProductQuantities = getProductQuantities;
        self.getProductGroupOptions = getProductGroupOptions;
        self.getShoppingRates = getShoppingRates;
        self.getImpliedWarranties = getImpliedWarranties;
        self.getReturnPolicies = getReturnPolicies;
        self.getPublicationDurations = getPublicationDurations;
        self.getDeliveryHandlingTimes = getDeliveryHandlingTimes;

        self.isMultipleGroupOption = productSrvc.isMultipleGroupOption;
        self.isPossibleDisplayProductGroupOption = isPossibleDisplayProductGroupOption;
        self.onProductChange = onProductChange;
        self.onProductSearch = onProductSearch;
        self.getChosenOptionPks = getChosenOptionPks;
        self.onProductOptionChange = onProductOptionChange;
        self.initSelectedProductOpts = initSelectedProductOpts;
        self.checkProductDataComplete = checkProductDataComplete;
        self.cleanErrors = cleanErrors;

        activate();
        function activate() {
            onInitView();
        }

        function onInitView() {
            self.loading = true;

            self.getOffer()
                .then(function (offer) {
                    return $q.all([
                        getProducts(),
                        getProductQuantities(offer.product),
                        getProductGroupOptions(offer.product),
                        getShoppingRates(self.account.pk),
                        getImpliedWarranties(self.account.pk),
                        getReturnPolicies(self.account.pk),
                        getPublicationDurations(self.account.pk),
                        getDeliveryHandlingTimes(self.account.pk)
                    ]);
                })
                .then(function (results) {
                    self.checkProductDataComplete(self.offerData);
                    self.initSelectedProductOpts(self.offerData.chosen_options);
                })
                .catch(function (error) {
                    console.error("Error loading data:", error);
                })
                .finally(function () {
                    self.loading = false;
                });
        }

        function initSelectedProductOpts(chosenOptions){
            chosenOptions.forEach(function(opt) {
                self.selectedProductOptions[opt.options_group] = opt.pk;
            });
        }

        function checkProductDataComplete(offer) {
            var isComplete =
                offer.product &&
                offer.quantity &&
                offer.chosen_options &&
                offer.chosen_options.length > 0;

            self.isProductDataComplete = isComplete;
        }

        function getOffer(){
            return allegroOffersDataSrvc.get({pk: $state.params.pk}).$promise.then(
                function (response) {
                    self.offerData = response;
                    self.account = response.account;
                    delete response.account;
                    self.offerNumber = response.external_id;
                    self.offerSignature = response.signature;
                    return response;
                }
            );
        }

        function getProducts() {
            return productDataSrvc.allegroOptionsList().$promise.then(
                function (response) {
                    self.productOpts = response.results;
                    return response;
                }
            )
        }

        function getProductQuantities(productId){
            if (!productId) {
                return;
            }

            return productDataSrvc.getQuantities({pk: productId}).$promise.then(
                function (response) {
                    self.productQuantityOpts = response;
                    return response;
                }
            )
        }

        function getProductGroupOptions(productId){
            if (!productId) {
                return;
            }

            return productDataSrvc.getProductGroupOptions({pk: productId}).$promise.then(
                function (response) {
                    self.productGroupOptionsOpts = response;
                    return response;
                }
            )
        }

        function getShoppingRates(accountId){
            return allegroAccountDataSrvc.getShoppingRates({pk: accountId}).$promise.then(
                function (response) {
                    self.shoppingRateOpts = response.shippingRates;
                    return response;
                }
            )
        }

        function getImpliedWarranties(accountId){
            return allegroAccountDataSrvc.getImpliedWarranties({pk: accountId}).$promise.then(
                function (response) {
                    self.impliedWarrantyOpts = response.impliedWarranties;
                    return response;
                }
            )
        }

        function getReturnPolicies(accountId){
            return allegroAccountDataSrvc.getReturnPolicies({pk: accountId}).$promise.then(
                function (response) {
                    self.returnPolicyOpts = response.returnPolicies;
                    return response;
                }
            )
        }

        function getPublicationDurations(accountId){
            return allegroAccountDataSrvc.getPublicationDurations({pk: accountId}).$promise.then(
                function (response) {
                    self.publicationDurationOpts = response;
                    return response;
                }
            )
        }

        function getDeliveryHandlingTimes(accountId){
            return allegroAccountDataSrvc.getDeliveryHandlingTimes({pk: accountId}).$promise.then(
                function (response) {
                    self.deliveryHandlingTimeOpts = response;
                    return response;
                }
            )
        }

        function isPossibleDisplayProductGroupOption(opt){
            var opts = opt.options.filter(function(item){
                return item.enter_values_possible === true;
            });
            return opts.length > 0;
        }

        function onProductChange(product) {
            self.offerData.quantity = null;
            self.offerData.chosen_options = [];
            self.selectedProductOptions = {};

            self.getProductQuantities(product.pk);
            self.getProductGroupOptions(product.pk);
        }

        function onProductSearch(params) {
            if (!params) {
                params = {};
            }
            return productDataSrvc.allegroOptionsList(params).$promise;
        }

        function getChosenOptionPks(){
            var pks = [];

            for (var key in self.selectedProductOptions) {
                if (angular.isArray(self.selectedProductOptions[key])) {
                    self.selectedProductOptions[key].map(function(pk) {
                        pks.push(pk);
                    });
                } else {
                    pks.push(self.selectedProductOptions[key]);
                }
            }
            return pks
        }

        function onProductOptionChange(option){}

        function updateOffer() {
            if (self.saving) {
                return;
            }

            self.saving = true;
            self.offerData.chosen_options = self.getChosenOptionPks();

            allegroOffersDataSrvc.update({pk: self.offerData.pk}, self.offerData)
                .$promise.then(function(response) {
                    notificationSrvc.notification("success", allegroOfferMessagesConst.update);
                    if (Object.keys(response.external_errors).length === 0) {
                        $state.go('layout.allegro-accounts.detail.offers', { pk: self.account.pk });
                    } else {
                        errorNotificationSrvc.displayErrors(response.external_errors);
                        $state.go('layout.allegro-offers.update', { pk: response.pk });
                    }
                }).catch(function(response){
                    if (response.status === 400){
                        errorNotificationSrvc.displayErrors(response.data);
                        self.serverErrors = response.data;
                    } else {
                        notificationSrvc.notification("error", response.statusText);
                    }
                }).finally(function () {
                    self.saving = false;
                });
        }

        function cleanErrors(key){
            self.serverErrors[key] = [];
        }
    }
})();
